module.exports = __webpack_public_path__ + "static/media/selectRightArrow.5dbc8265.svg";